export default __webpack_public_path__ + "static/media/AddAFriend_159x150.67ef5d84.png";